// @ts-nocheck

import { createSelector } from 'reselect';

import { getKLRoundRulesConfig } from '../../constants/labels';
import { getRoundIdFromProps, selectSpecificKLRule } from '../rules';

const emptyObj = {};

const selectKLRoundRulesConfig = createSelector(
  selectSpecificKLRule,
  (specific) => getKLRoundRulesConfig(specific) ?? emptyObj,
);

const selectRuleConfigByRoundId = createSelector(
  [selectKLRoundRulesConfig, getRoundIdFromProps],
  (rulesByRound, roundId) => rulesByRound[roundId] ?? emptyObj,
);

const selectKLRoundRulesProps = createSelector([selectRuleConfigByRoundId], (rulesConfig) => ({
  rulesConfig,
}));

export default selectKLRoundRulesProps;
